import * as mainTerms from '../mainTerms';

const adTitle = mainTerms.Setting.ad.title;

const ad = mainTerms.Setting.ad.default;
const adFolderDef = mainTerms.Setting.adFolder.default;
export const SetAd = {
    saveWeight: {
        success: '내용이 반영되었습니다.',
        error: {
            fail: '정상적으로 반영되지 못했습니다.\n다시 시도해주세요.',
        }
    },
    getResponse: {
        error: {
            fail: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신해주세요.',
        },
    },
    deleteAd: {
        success: '삭제되었습니다.',
        error: {
            fail: '정상적으로 삭제하지 못했습니다.\n다시 시도해주세요.',
        }
    },
    changeStatus: {
        success: '정상적으로 변경되었습니다.',
        error: {
            fail: '정상적으로 변경되지 못했습니다.\n다시 시도해주세요.',
        }
    },
    other: {
        warning: {
            invalidRequest: adTitle + '는 URI을 통해 직접 접근하실 수 없습니다.\n웹페이지 내에서 접근해주세요.',
        },
    }
}
export const EditAd = {
    editing: {
        success: ad + ' 설정에 성공했습니다.',
        error: {
            getResponse: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신해주세요.',
            fail: ad + ' 설정에 실패했습니다.\n다시 시도해주세요.',
        },
        confirm: {
            removeImgWarning: '이 이미지를 다시 추가하기 위해서는 본 이미지를 포함한 ' + adFolderDef + '를 다시 불러와야 합니다.\n계속 진행하시겠습니까?'
        }
    },
    getResponse: {
        error: {
            fail: '정상적으로 데이터를 읽어오지 못했습니다.\n페이지를 갱신해주세요.',
        },
    },
    other: {
        confirm: {
            warnIsModified: '변경 중인 내용은 저장되지 않습니다.\n정말 취소하시겠습니까?',
        },
        warning: {
            invalidRequest: adTitle + '는 URI을 통해 직접 접근하실 수 없습니다.\n웹페이지 내에서 접근해주세요.',
        }
    },
}